import SHAREBOX_I32_REOPEN_STEPS from './i32';

const SHAREBOX_W64_REOPEN_STEPS = SHAREBOX_I32_REOPEN_STEPS;

export default SHAREBOX_W64_REOPEN_STEPS;
